module.exports = __webpack_public_path__ + "img/noodles.be5030ca.webp";